module.exports = __webpack_public_path__ + "img/ty-text.8c1086f4.png";